import store, { actions } from "../../redux";
import { CircleProps } from "../../redux/slices/circles/circles";
import { API_INSTANCES } from "../api_instance";
import { handleError } from "../errors";

const dispatch = store.dispatch;

const getListCircles = () => {
  return API_INSTANCES.CIRCLE.getListCircles()
    .then((response) => {
      const data = response.data as CircleProps.Circle[];
      dispatch(actions.circle.setListOfCircles(data));
    })
    .catch((error) => {
      handleError(error, "getListCircles");
    });
};

const createCircle = (data: CircleProps.createCirclePayload) => {
  dispatch(actions.circle.setCreateCircle_API_STATUS("progress"));
  return API_INSTANCES.CIRCLE.createCircle(data)
    .then((response) => {
      const data = response.data as CircleProps.Circle;
      dispatch(actions.circle.setCircle(data));
      dispatch(actions.circle.setCreateCircle_API_STATUS("success"));
    })
    .catch((error) => {
      handleError(error, "createCircle");
      dispatch(actions.circle.setCreateCircle_API_STATUS("error"));
    });
};

const deleteCircle = (data: CircleProps.deleteCirclePayload) => {
  dispatch(actions.circle.setDeleteCircle_API_STATUS("progress"));
  return API_INSTANCES.CIRCLE.deleteCircle(data)
    .then(() => {
      dispatch(actions.circle.setRemoveCircle(data));
      dispatch(actions.circle.setDeleteCircle_API_STATUS("success"));
    })
    .catch((error) => {
      handleError(error, "deleteCircle");
      dispatch(actions.circle.setDeleteCircle_API_STATUS("error"));
    });
};

const addUserToCircle = (data: CircleProps.addUserToCirclePayload) => {
  return API_INSTANCES.CIRCLE.addUserToCircle(data)
    .then((response) => {
      const data = response.data as CircleProps.addUserToCircleResponse;
      dispatch(actions.circle.setAddUserToCircle(data));
    })
    .catch((error) => {
      handleError(error, "addUserToCircle");
    });
};

const removeUserFromCircle = (
  data: CircleProps.removeUserFromCirclePayload
) => {
  return API_INSTANCES.CIRCLE.removeUserFromCircle(data)
    .then((response) => {
      const data = response.data as CircleProps.removeUserFromCircleResponse;
      dispatch(actions.circle.setRemoveUserFromCircle(data));
    })
    .catch((error) => {
      handleError(error, "removeUserFromCircle");
    });
};

const showCircleDetails = (data: CircleProps.showCircleDetailsPayload) => {
  return API_INSTANCES.CIRCLE.showCircleDetails(data)
    .then(() => {})
    .catch((error) => {
      handleError(error, "showCircleDetails");
    });
};

const updateCircle = (data: CircleProps.updateCirclePayload) => {
  dispatch(actions.circle.setCreateCircle_API_STATUS("progress"));
  return API_INSTANCES.CIRCLE.updateCircle(data)
    .then((response) => {
      const data = response.data as CircleProps.Circle;
      dispatch(actions.circle.setupdateCircle(data));
      dispatch(actions.circle.setCreateCircle_API_STATUS("success"));
    })
    .catch((error) => {
      handleError(error, "updateCircle");
      dispatch(actions.circle.setCreateCircle_API_STATUS("error"));
    });
};

export const CIRCLE = {
  getListCircles,
  createCircle,
  deleteCircle,
  addUserToCircle,
  removeUserFromCircle,
  showCircleDetails,
  updateCircle,
};
